export const MIN_DESKTOP_WIDTH = 1000;
